export default {
  wsServer: 'ws://127.0.0.1:3901/',
  apiServer: 'http://127.0.0.1:3900/',
  s3: true

}